/* eslint-disable react/no-danger */
import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import styles from './styles.scss'

const ChoiceField = ({
  onChange,
  options,
  value,
  loading,
  errorMessage,
  name,
  required,
}) => {
  const hasError = !!errorMessage

  return (
    <div className={classNames(
        styles.wrapper,
        { [styles.error]: hasError }
      )}
    >
      {options.map(option => (
        <div className={styles.option} key={option.value}>
          <input
            id={`${name}-${option.value}`}
            key={option.value}
            value={option.value}
            name={name}
            onChange={onChange}
            type="radio"
            checked={option.value === value}
            required={required}
            disabled={loading}
          />
          <label htmlFor={`${name}-${option.value}`}>
            <span className={styles.icon} />
            <div className={styles.labelText}>{option.label}</div>
            {option.extra}
          </label>
        </div>
      ))}
      {hasError &&
        <span className={styles.errorText}>{errorMessage}</span>
      }
    </div>
  )
}

ChoiceField.defaultProps = {
  value: '',
  loading: false,
  onChange: f => f,
  errorMessage: '',
  required: false,
  options: [],
}

ChoiceField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  loading: PropTypes.bool,
  onChange: PropTypes.func,
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    value: PropTypes.any.isRequired,
    extra: PropTypes.node,
  })),
}

export default ChoiceField



// WEBPACK FOOTER //
// ./components/form/ChoiceField/index.jsx